import { useEffect, useState } from 'react';
import { IconCheck, IconX, IconAlertTriangle, IconInfoCircle } from '@tabler/icons-react';

const ICONS = {
  success: <IconCheck size={15} stroke={2} />,
  error:   <IconX size={15} stroke={2} />,
  warning: <IconAlertTriangle size={15} stroke={1.5} />,
  info:    <IconInfoCircle size={15} stroke={1.5} />,
};

const COLOURS = {
  success: { bg: 'var(--color-success)',       text: '#fff' },
  error:   { bg: 'var(--color-danger)',         text: '#fff' },
  warning: { bg: 'var(--color-warning)',        text: '#fff' },
  info:    { bg: 'var(--color-text-primary)',   text: '#fff' },
};

// Global toast state
let toastListeners = [];
let toastQueue = [];

export const toast = {
  show: (message, type = 'info', duration = 3000) => {
    const id = Date.now();
    const item = { id, message, type, duration };
    toastQueue = [...toastQueue, item];
    toastListeners.forEach(fn => fn([...toastQueue]));
    setTimeout(() => {
      toastQueue = toastQueue.filter(t => t.id !== id);
      toastListeners.forEach(fn => fn([...toastQueue]));
    }, duration);
  },
  success: (msg, duration) => toast.show(msg, 'success', duration),
  error:   (msg, duration) => toast.show(msg, 'error', duration),
  warning: (msg, duration) => toast.show(msg, 'warning', duration),
  info:    (msg, duration) => toast.show(msg, 'info', duration),
};

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    toastListeners.push(setToasts);
    return () => {
      toastListeners = toastListeners.filter(fn => fn !== setToasts);
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      zIndex: 9999,
    }}>
      {toasts.map(t => {
        const c = COLOURS[t.type] || COLOURS.info;
        return (
          <div key={t.id} style={{
            background: c.bg,
            color: c.text,
            borderRadius: 'var(--radius-md)',
            padding: '10px 16px',
            fontSize: 'var(--font-size-base)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            boxShadow: 'var(--shadow-md)',
            minWidth: 240,
            maxWidth: 380,
            animation: 'slideIn 0.2s ease',
          }}>
            {ICONS[t.type]}
            {t.message}
          </div>
        );
      })}
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to   { transform: translateX(0);   opacity: 1; }
        }
      `}</style>
    </div>
  );
}